module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAALVBMVEUre8sre8sre8sre8v////z9/yoyeqCseBindhJjtI3g87h7Pjg7PfI3fLH3PHHMKGEAAAAA3RSTlPmSedIzOtbAAAASElEQVQY02MQMIYCRgZmGNOAwRgOKGGaF8OZLR4wpmWI62Qoc42Lyy4o84mLiy+EaeYCBMlQbS4uQAInEw4oZyI8b8QgBA8SAOZSNvAMAMSVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_up3.png
// module id = T2vH
// module chunks = 9